import styled from 'styled-components'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const OrderPRCounter = styled.div`
  background: ${colors.red};
  color: ${colors.white};
  border-radius: 8px;
  height: 20px;
  width: 20px;
  text-align: center;
  text-align-vertical: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 4px;

  ${media('lg')} {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
`

export const OrderPRBullet = styled.div`
  background: ${colors.red};
  color: ${colors.white};
  border-radius: 8px;
  height: 8px;
  width: 8px;
  text-align: center;
  margin-left: 8px;
`

export const Badge = styled.div`
  background: ${colors.red};
  color: ${colors.white};
  border-radius: 8px;
  height: 24px;
  width: 24px;
  text-align: center;
  margin-left: 18px;
`
